var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,20V18H19v2H5Zm0-3.5L3.73,8.48q-0.05,0-0.11,0.01T3.5,8.5q-0.63,0-1.06-0.44T2,7T2.44,5.94T3.5,5.5T4.56,5.94T5,7Q5,7.18 4.96,7.32T4.88,7.6L8,9l3.13-4.28q-0.27-0.2-0.45-0.52T10.5,3.5q0-0.63 0.44-1.06T12,2t1.06,0.44T13.5,3.5q0,0.38-0.17,0.7T12.88,4.72L16,9l3.13-1.4q-0.05-0.13-0.09-0.27T19,7q0-0.63 0.44-1.06T20.5,5.5t1.06,0.44T22,7T21.56,8.06T20.5,8.5q-0.05,0-0.11-0.01q-0.06-0.01-0.11-0.01L19,16.5H5Zm1.7-2H17.3l0.65-4.18l-2.62,1.15L12,6.9L8.68,11.48L6.05,10.33L6.7,14.5Zm5.3,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.99778f1b.svg";
export { ForwardRef as ReactComponent };